// extracted by mini-css-extract-plugin
module.exports = {"money":"FlowDetail_style_money__3g6jR"};